import { render, staticRenderFns } from "./CourseListPage.vue?vue&type=template&id=588b717e&scoped=true&"
import script from "./CourseListPage.vue?vue&type=script&lang=js&"
export * from "./CourseListPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseListPage.vue?vue&type=style&index=0&id=588b717e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b717e",
  null
  
)

export default component.exports